var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.869,
    height: 30.627,
    viewBox: "0 0 21.869 30.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M370.274,196a.065.065,0,0,0,.018-.053c.018-.018.018-.036.036-.071,0-.018.018-.036.018-.053s.018-.036.018-.053a.586.586,0,0,0,0-.25c0-.018-.018-.036-.018-.053s-.018-.036-.018-.053c-.018-.018-.018-.036-.036-.071a.062.062,0,0,0-.018-.036.386.386,0,0,0-.071-.089l-3.369-3.369a.63.63,0,1,0-.891.891l2.3,2.3H360.7a.624.624,0,0,0,0,1.248h7.523l-2.3,2.3a.63.63,0,0,0,.891.891l3.369-3.369a.236.236,0,0,0,.089-.107Z",
    transform: "translate(-348.508 -181.967)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M192.943,40.073V51.25H191.7V40.7h-9l5.829,2.05a.632.632,0,0,1,.428.588V69.469a.6.6,0,0,1-.267.517.642.642,0,0,1-.357.107.9.9,0,0,1-.214-.036l-9.323-3.245h-.017a.061.061,0,0,1-.036-.018c-.018-.018-.036-.018-.071-.036-.018,0-.018-.018-.036-.018-.018-.018-.053-.036-.071-.053l-.018-.018c-.018-.036-.053-.053-.071-.089l-.018-.018a.135.135,0,0,1-.036-.071c0-.018-.018-.018-.018-.036a.107.107,0,0,1-.018-.071v-.036c0-.036-.018-.071-.018-.107V40.072a.39.39,0,0,1,.018-.143c0-.018,0-.018.018-.036.018-.036.018-.071.036-.089a.061.061,0,0,1,.018-.036.249.249,0,0,1,.053-.071l.036-.036c.018-.036.053-.053.071-.071l.018-.018a.773.773,0,0,1,.125-.071c.018,0,.018,0,.036-.018a.193.193,0,0,1,.089-.018H192.3a.6.6,0,0,1,.642.606Z",
    transform: "translate(-178.361 -39.465)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M366.76,283.919V295.1a.62.62,0,0,1-.624.624H364v-1.248h1.515V283.919h1.248Z",
    transform: "translate(-352.178 -268.354)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d8610c0f1584d68a0b6b942de49b9004.svg";
export { ForwardRef as ReactComponent };